export default "__VITE_ASSET__Dys6dBLV__"